import { makeAutoObservable } from 'mobx';
import { RegisterManager } from '../../../../core-logic/modules/authorization/managers/RegisterManager';

class RegisterUIManager {
  constructor(private registerManager: RegisterManager) {
    makeAutoObservable(this, {});
  }

  get coreManager() {
    return this.registerManager;
  }
}

export { RegisterUIManager };
